import { render, staticRenderFns } from "./FieldActions.vue?vue&type=template&id=38cbef2f&scoped=true&"
import script from "./FieldActions.vue?vue&type=script&lang=js&"
export * from "./FieldActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbef2f",
  null
  
)

export default component.exports